module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.playlist.length > 0),
      expression: "playlist.length>0"
    }],
    staticClass: "player"
  }, [_c('transition', {
    attrs: {
      "name": "normal"
    },
    on: {
      "enter": _vm.enter,
      "after-enter": _vm.afterEnter,
      "leave": _vm.leave,
      "after-leave": _vm.afterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fullScreen),
      expression: "fullScreen"
    }],
    staticClass: "normal-player",
    style: ({
      background: _vm.controllerBackgroundColor
    })
  }, [_c('m-header'), _vm._v(" "), _c('div', {
    staticClass: "background"
  }), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "back",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "icon-back"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.name)
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.album)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "middle",
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        return _vm.middleTouchStart($event)
      },
      "touchmove": function($event) {
        $event.preventDefault();
        return _vm.middleTouchMove($event)
      },
      "touchend": _vm.middleTouchEnd
    }
  }, [_c('div', {
    ref: "middleL",
    staticClass: "middle-l"
  }, [_c('div', {
    ref: "cdWrapper",
    staticClass: "cd-wrapper"
  }, [_c('div', {
    staticClass: "cd",
    class: _vm.cdCls
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.currentSong.image
    }
  })])])]), _vm._v(" "), _c('scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentShow === 'lyric'),
      expression: "currentShow==='lyric'"
    }],
    ref: "lyricList",
    staticClass: "middle-r"
  }, [_c('div', {
    staticClass: "lyric-wrapper"
  }, [_c('p', {
    ref: "lyricLine",
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.lyric)
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "dot-wrapper"
  }, [_c('span', {
    staticClass: "dot",
    class: {
      'active': _vm.currentShow === 'cd'
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dot",
    class: {
      'active': _vm.currentShow === 'lyric'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "progress-wrapper"
  }, [_c('span', {
    staticClass: "time time-l"
  }, [_vm._v(_vm._s(_vm.format(_vm.currentTime)))]), _vm._v(" "), _c('div', {
    staticClass: "progress-bar-wrapper"
  }, [_c('progress-bar', {
    attrs: {
      "percent": _vm.percent
    },
    on: {
      "percentChange": _vm.onProgressBarChange
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "time time-r"
  }, [_vm._v(_vm._s(_vm.format(_vm.currentSong.duration)))])]), _vm._v(" "), _c('div', {
    staticClass: "operators"
  }, [_c('div', {
    staticClass: "icon i-left",
    on: {
      "click": _vm.changeMode
    }
  }, [_c('i', {
    class: _vm.iconMode
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-left",
    class: _vm.disableCls
  }, [_c('i', {
    staticClass: "icon-prev",
    on: {
      "click": _vm.prev
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-center",
    class: _vm.disableCls
  }, [_c('i', {
    class: _vm.playIcon,
    on: {
      "click": _vm.togglePlaying
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-right",
    class: _vm.disableCls
  }, [_c('i', {
    staticClass: "icon-next",
    on: {
      "click": _vm.next
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "icon i-right"
  }, [_c('i', {
    staticClass: "icon",
    class: _vm.getFavoriteIcon(_vm.currentSong),
    on: {
      "click": function($event) {
        _vm.toggleFavorite(_vm.currentSong)
      }
    }
  })])])])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "mini"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullScreen),
      expression: "!fullScreen"
    }],
    staticClass: "mini-player",
    style: ({
      background: _vm.controllerBackgroundColor
    }),
    on: {
      "click": _vm.open
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    class: _vm.cdCls,
    attrs: {
      "width": "40",
      "height": "40",
      "src": _vm.currentSong.image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('h2', {
    staticClass: "name",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.name)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "desc",
    domProps: {
      "innerHTML": _vm._s(_vm.currentSong.singer)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('ProgressCircle', {
    attrs: {
      "radius": _vm.radius,
      "percent": _vm.percent
    }
  }, [_c('i', {
    staticClass: "icon-mini",
    class: _vm.miniIcon,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.togglePlaying($event)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('i', {
    staticClass: "icon-playlist"
  })])])]), _vm._v(" "), _c('play-list', {
    ref: "playlist"
  }), _vm._v(" "), _c('audio', {
    ref: "audio",
    attrs: {
      "type": "audio/mpeg",
      "src": _vm.currentSong.url
    },
    on: {
      "play": _vm.ready,
      "error": _vm.error,
      "timeupdate": _vm.updateTime,
      "ended": _vm.end
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-409e5c2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/player/player.vue
// module id = 569
// module chunks = 1